module.exports = __webpack_public_path__ + "img/paladan.32e73b76.png";